import { render, staticRenderFns } from "./ResultsAverageTicketCard.vue?vue&type=template&id=7185bcd1"
import script from "./ResultsAverageTicketCard.vue?vue&type=script&lang=js"
export * from "./ResultsAverageTicketCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports